<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft">
    <div :class="$style.dropdown">
      <a-avatar v-bind="avatarProps" shape="square" size="large" />
    </div>
    <a-menu slot="overlay">
      <a-menu-item>
        {{loggedUser.email}}
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <a href="javascript: void(0);" @click="logout">
          <i :class="$style.menuIcon" class="fe fe-log-out"></i>
          Deslogar
        </a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>
      

<script>
import store from '@/store'
export default {
  data: function () {
    return {
      count: 7,
    }
  },
  computed: {
    loggedUser(){
      if(this.$auth.user){
        return this.$auth.user
      }
      return {avatar: 'default'};
    },
    avatarProps(){
      const avatar = {
        icon: "user",
      };
      if(this.loggedUser.picture){
        return {
          src: this.loggedUser.picture,
        }
      }
      return avatar;
    },
  },
  methods: {
    setLoadingState(state) {
      store.commit('UPDATE_LOADING_STATE', { active: state })
    },
    async logout() {
      this.setLoadingState(true)
      await this.$auth.logout()
      this.setLoadingState(false)
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
